import { render, staticRenderFns } from "./GraficosDinamicos.vue?vue&type=template&id=fbadee54&"
import script from "./GraficosDinamicos.vue?vue&type=script&lang=js&"
export * from "./GraficosDinamicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports